export enum ActivityTypes {
  VISIT = 1,
  CLICK = 2,
}
